export const getNavigationOffset = () => {
  return ['.navigation', '.submenu']
    .map((selector) => {
      const el: HTMLElement | null = document.querySelector(selector);
      return el ? el.offsetHeight : 0;
    })
    .reduce((accumulator, currentValue) => accumulator + currentValue);
};
